import React, { useEffect, useState, createContext } from 'react'

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { useLocation } from 'react-router-dom';
import AppointmentsApi from "../../../Classes/API/Appointments/AppointmentsApi";
import SearchStringOrIntReq from '../../../Classes/Models/Requests/SearchStringOrIntReq';
import Swal from 'sweetalert2';
import AppHourDetailsCard from './AppHourDetailsCard';
 

const index = () => {
    const { state } = useLocation();
    const [IsLoaded, setIsLoaded] = useState(false)
    const [AppHour, setAppHour] = useState({})



    useEffect(() => {
        if (!IsLoaded) {
            GetAppHourById(state.AppHour.id)
        }

    }, [IsLoaded])


    const GetAppHourById = async (Id) => {
        let req = new SearchStringOrIntReq();
        req.SearchInt = Id;

        let res = await AppointmentsApi.GetAppoinmentHourById(req);

        if (res.status == "Success") {
            setIsLoaded(true);
            setAppHour(res.data)
        }
        else {
            Swal.fire("Failed", res.message, "error");
        }
    }


    if(!IsLoaded){
        return(
            <div>
                Loading...
            </div>
        )
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
 
            <AppHourDetailsCard AppHour={AppHour} />
        </DashboardLayout>
    )
}

export default index